import React, { useEffect, useState } from "react";
import PdfViewer from "../../components/ordonnance/PdfViewer";
import { API } from "../../services/api";

export default function PreviewAttachmentModal({ attachment, onClose }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!attachment?.id && !attachment?.path) return undefined;

        let objectUrl = null;
        let cancelled = false;
        setLoading(true);
        setError(null);
        setBlobUrl(null);

        const request = attachment.id
            ? API.get(`/ordonnances/${attachment.id}/content`, { responseType: "blob" })
            : API.get(attachment.path, { responseType: "blob" });

        request
            .then(response => {
                if (cancelled) return;
                const blob = response.data;
                objectUrl = URL.createObjectURL(blob);
                setBlobUrl(objectUrl);
            })
            .catch(() => {
                if (!cancelled) setError("Impossible de charger cette pièce jointe.");
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [attachment?.id, attachment?.name, attachment?.path]);

    useEffect(() => {
        const handleEscape = event => {
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [onClose]);

    if (!attachment) return null;

    return (
        <div
            className="preview-attachment-backdrop"
            role="presentation"
            onMouseDown={event => event.target === event.currentTarget && onClose()}
        >
            <div
                className="preview-attachment-modal"
                role="dialog"
                aria-modal="true"
                aria-label={`Aperçu de ${attachment.name || "la pièce jointe"}`}
            >
                <header>
                    <button type="button" className="preview-attachment-back" onClick={onClose}>
                        ← Retour à l’aperçu
                    </button>
                    <strong title={attachment.name}>{attachment.name || "Pièce jointe"}</strong>
                    <button type="button" className="preview-attachment-close" aria-label="Fermer la pièce jointe" onClick={onClose}>×</button>
                </header>
                <div className="preview-attachment-content">
                    {loading && <p>Chargement de la pièce jointe…</p>}
                    {error && <p className="preview-attachment-error">{error}</p>}
                    {!loading && !error && blobUrl && <PdfViewer url={blobUrl} fileName={attachment.name} />}
                    {!loading && !error && !blobUrl && <p>Aucun aperçu disponible.</p>}
                </div>
            </div>
        </div>
    );
}
